import { APICfg } from 'services/api/api'
import { APILocation } from '../location/types/api/response-models'
import { ProductSection, ProductSectionToAPI } from '../types'
import { productSectionParse } from '../utils'

export type LocationSection = ProductSection<APILocation>

type LocationSectionToApi = ProductSectionToAPI

const apiCfg: APICfg = {
  endpoint: 'locationsections',
  parse: productSectionParse,
  write: async (req: LocationSection): Promise<LocationSectionToApi> => req,
}
export default apiCfg
